import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import WhySection from './components/WhySection';
import ContentSections from './components/ContentSections';
import BlogSection from './components/BlogSection';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://kakobuypolska.cam';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebSite',
          name: 'Kakobuy Spreadsheet Polska',
          url: SITE_URL + '/',
          inLanguage: 'pl',
          description: 'Największa lista najlepszych produktów z Chin dla polskich kupujących.',
        })}
      </script>
      <script type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'Organization',
          name: 'Kakobuy Polska',
          url: SITE_URL + '/',
          logo: { '@type': 'ImageObject', url: 'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/9f7209ca9e1d80750ccbea8c559f256f.png' },
          sameAs: ['https://kaspreadsheet.com'],
        })}
      </script>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <WhySection />
        <ContentSections />
        <BlogSection />
      </main>
      <Footer />
    </div>
  );
}